<template>
    <v-form ref="form" v-model="valid" class="events-filter">
        <v-layout row>
            <v-flex>
                <div class="events-filter__title events-filter__title--top">VRN</div>
                <v-text-field
                    v-model="form.VRN"
                    label="Vehicle register number"
                    class="small-field"
                    required
                    outline
                    single-line
                ></v-text-field>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <div class="events-filter__title">From Date</div>
                <date-picker
                    v-model="form.dateFrom"
                    placeholder="Pick date"
                    :clearable="false"
                    :default-value="new Date()"
                    :disabled-date="disabledAfterToday"
                    type="date"
                ></date-picker>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <div class="events-filter__title">To Date</div>
                <date-picker
                    v-model="form.dateTo"
                    placeholder="Pick date"
                    :clearable="false"
                    :default-value="new Date()"
                    :disabled-date="disabledFromDateFromToToday"
                    type="date"
                ></date-picker>
            </v-flex>
        </v-layout>
<!--        Na VT są floty, tutaj endpoint nie przewiduje-->
<!--        <v-layout>-->
<!--            <v-flex>-->
<!--                <div class="events-filter__title">Fleets</div>-->
<!--                <fleet-autocomplete-->
<!--                    v-model="form.fleets"-->
<!--                    multiple-->
<!--                    class="small-field"-->
<!--                ></fleet-autocomplete>-->
<!--            </v-flex>-->
<!--        </v-layout>-->
<!--        <v-layout>-->
<!--            <v-flex>-->
<!--                <div class="events-filter__title">Driver Name</div>-->
<!--                <v-select-->
<!--                    :getDrivers="getDriver"-->
<!--                    v-model="form.drivers"-->
<!--                    label="Select driver name"-->
<!--                    class="small-field"-->
<!--                    item-text="name"-->
<!--                    item-value="id"-->
<!--                    multiple-->
<!--                    outline-->
<!--                    single-line-->
<!--                ></v-select>-->
<!--            </v-flex>-->
<!--        </v-layout>-->
<!--        Na VT są evtnt categories, tutaj endpoint nie przewiduje-->
<!--        <v-layout>-->
<!--            <v-flex>-->
<!--                <div class="events-filter__title">Event Type Category</div>-->
<!--                <v-select-->
<!--                    v-model="form.eventCategories"-->
<!--                    :items="getEventCategories"-->
<!--                    label="Select event category"-->
<!--                    class="small-field"-->
<!--                    item-text="name"-->
<!--                    item-value="id"-->
<!--                    multiple-->
<!--                    outline-->
<!--                    single-line-->
<!--                ></v-select>-->
<!--            </v-flex>-->
<!--        </v-layout>-->
        <v-layout>
            <v-flex>
                <div class="events-filter__title">Event Type</div>
                <v-select
                    v-model="form.eventTypes"
                    :items="availableEventTypes"
                    label="Select event type"
                    class="small-field"
                    item-text="name"
                    item-value="id"
                    multiple
                    outline
                    single-line
                ></v-select>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <div class="events-filter__title">Event Classification</div>
                <v-select
                    v-model="form.eventClassifications"
                    :items="filteredEventClassifications"
                    label="Select event classification"
                    class="small-field"
                    item-text="key"
                    item-value="id"
                    outline
                    single-line
                    multiple
                ></v-select>
            </v-flex>
        </v-layout>
    </v-form>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import FleetAutocomplete from '@/views/Fleets/components/FleetAutocomplete.vue'
import DriversApi from '@/api/DriversApi'
import DatePicker from 'vue2-datepicker'

const driversApi = new DriversApi();

export default {
    name: 'ResourceEventFilter',
    components: {
        FleetAutocomplete,
        DatePicker
    },
    data () {
        return {
            valid: false,
            todayDate: null,
            isFromDatePickerShow: false,
            isToDatePickerShow: false
        }
    },
    props: {
        form: {
            type: Object,
            required: true
        }
    },
    mounted () {
        this.todayDate = moment().format('YYYY-MM-DD')
    },
    computed: {
        ...mapGetters({
            getEventClassifications: 'dictionaryModule/getEventClassifications',
            getEventTypes: 'dictionaryModule/getEventTypes',
            getEventCategories: 'dictionaryModule/getEventCategories'
        }),
        filteredEventClassifications () {
            return this.getEventClassifications.filter(event => {
                return 1 < event.id
            })
        },
        availableEventTypes () {
          const unavailableCategory = this.getEventCategories.find(category => category.key === "None")
            return this.getEventTypes.filter(event => event.categoryId !== unavailableCategory.id)
        },
    },
    methods: {
        async getDriver () {
            const result = await driversApi.getDriver()

            return {
                items: result.payload.data
            }
        },
        disabledAfterToday (dateFrom) {
            const today = new Date()
            this.isDateFrom = dateFrom
            return dateFrom > today
        },
        disabledFromDateFromToToday (dateTo) {
            const today = new Date()

            return dateTo < this.isDateFrom || dateTo > today
        }
    }
}
</script>

<style scoped lang="scss">
.events-filter {
    &__title {
        margin-bottom: 10px;

        &--top {
            margin-top: 20px;
        }
    }
}

::v-deep .v-text-field.v-text-field--enclosed .v-input__prepend-outer,
.v-text-field.v-text-field--enclosed .v-input__prepend-inner,
.v-text-field.v-text-field--enclosed .v-input__append-inner,
.v-text-field.v-text-field--enclosed .v-input__append-outer {
    display: none !important;
}

::v-deep .v-input .v-input__slot {
    background-color: #fff !important;
}

::v-deep .v-text-field.v-text-field--enclosed .v-text-field__details {
    margin-bottom: 0;
}

::v-deep .mx-datepicker {
    margin-bottom: 10px;
}
</style>
